import React, { useState, useEffect } from "react";
import { X, ImagePlus, Loader2 } from "lucide-react";
import uploadFileToCloudinary from "../../../utils/uploadFileToCloudinary";
import axios from "axios";
const BlogCreateModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    category: "",
    description: "",
    image: null,
  });
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const uploadEnabled = Boolean(
    process.env.REACT_APP_CLOUDINARY_NAME && process.env.REACT_APP_UPLOAD_PRESET
  );

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, image: file });
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!uploadEnabled) return alert("Cloudinary not configured");

    try {
      setUploading(true);
      let imageUrl = null;

      if (formData.image) {
        const { uploadPromise } = uploadFileToCloudinary(
          formData.image,
          setProgress
        );
        const result = await uploadPromise;
        imageUrl = result.url;
      }

      await axios.post(`${process.env.REACT_APP_API_URL}/blogs/create`, {
        category: formData.category,
        description: formData.description,
        image: imageUrl,
      });

      onSuccess();
      onClose();
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to create blog");
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  if (!isOpen) return null;
  // useEffect(() => {
  //   if (!isOpen) {
  //     resetForm();
  //   }
  // }, [isOpen]);

  const handleClose = () => {
    resetForm();
    onClose();
  };
  const handleReset = () => {
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      category: "",
      description: "",
      image: null,
    });
    setPreview(null);
    setUploading(false);
    setProgress(0);
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="bg-white w-full max-w-lg rounded-xl shadow-2xl"
      >
        <div className="flex justify-between items-center p-6 border-b">
          <h3 className="text-2xl font-bold">Create New Blog</h3>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <input
            type="text"
            placeholder="Blog Category"
            value={formData.category}
            onChange={(e) =>
              setFormData({ ...formData, category: e.target.value })
            }
            className="w-full px-4 py-3 border rounded-lg focus:ring-1 focus:outline-none focus:ring-[#EDB5A4]"
            required
          />
          <textarea
            rows="5"
            placeholder="Blog Description"
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            className="w-full px-4 py-3 border rounded-lg focus:outline-none resize-none focus:ring-1 focus:ring-[#EDB5A4]"
          />
          <div className="space-y-3">
            <label className="block text-sm font-medium text-gray-700">
              Blog Image
            </label>

            {/* Upload Area */}
            <label
              className={`relative flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-8 text-center transition
    ${
      uploading
        ? "cursor-not-allowed opacity-70"
        : "cursor-pointer hover:border-[#EDB5A4]"
    }
    ${preview ? "border-solid border-gray-300" : "border-gray-400"}
  `}
            >
              <input
                type="file"
                accept="image/*"
                onChange={handleImage}
                disabled={uploading}
                className="hidden"
              />

              {/* Empty State */}
              {!preview && !uploading && (
                <>
                  <div className="w-14 h-14 rounded-full bg-orange-50 flex items-center justify-center mb-3">
                    <ImagePlus className="w-7 h-7 text-[#EDB5A4]" />
                  </div>

                  <p className="text-sm font-medium text-gray-700">
                    Click to upload or drag and drop
                  </p>

                  <p className="text-xs text-gray-500 mt-1">PNG, JPG, WEBP</p>
                </>
              )}

              {/* Uploading State */}
              {uploading && (
                <div className="w-full">
                  <div className="flex items-center justify-center gap-2 text-sm text-gray-600 mb-3">
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Uploading image…
                  </div>

                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-orange-500 h-2 rounded-full transition-all"
                      style={{ width: `${progress}%` }}
                    />
                  </div>

                  <p className="text-xs text-gray-500 text-center mt-2">
                    {progress}%
                  </p>
                </div>
              )}

              {/* Preview */}
              {preview && !uploading && (
                <img
                  src={preview}
                  alt="Preview"
                  className="w-full h-52 object-cover rounded-lg"
                />
              )}
            </label>
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-6 flex-1 py-3 border rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={uploading}
              className="flex-1 px-6 py-3 bg-primaryBtnColor text-white rounded-lg disabled:opacity-70"
            >
              {uploading ? "Creating..." : "Create Blog"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BlogCreateModal;
